import { Pipe, PipeTransform } from '@angular/core';
import { ICombineEngine } from '../interfaces';
import { find, chain, min, groupBy } from 'lodash';

@Pipe({
    name: 'duplicatedAddValues'
})
export class DuplicatedAddValuesPipe implements PipeTransform {

    transform(engines: ICombineEngine[], args?: any): ICombineEngine[] {
        if (engines.length > 1) {
            //  - regroupe par addvalues (genKey) 
            //  - chercher le moins cher (min) de chaque groupe
            //  - vérfier si googleHotelAds exists & combine min != combine googleHotelAds
            // la fonction flatten de lodash aplatir le tableau multidimensionnel en un tableau à une dimension
            return chain(engines).map(e => {
                e.genKey = e.combine.addedvalues.map(addvalue => (addvalue.category.replace(/\s/g, '').concat('-', addvalue.name.replace(/\s/g, ''))).toLowerCase()).sort().join('_')
                return e
            }).groupBy('genKey')
                .map(values => {
                    let isGoogleHotel: ICombineEngine | null = find(values, (value: ICombineEngine) => value.combine.isGoogleHotelAds),
                        _min: ICombineEngine | null = min(values, 'combine.ttc')
                    if (isGoogleHotel && isGoogleHotel.combine.indexSearch != _min.combine.indexSearch) {
                        return [_min, isGoogleHotel]
                    }
                    return [_min]
                })
                .flatten()
                .value()
        }
        return engines;
    }

}
